import { generateKeys } from '../utils';
export const trackEventsTypes = generateKeys({
    seminars: {
        label: 'Seminars',
        value: 'seminars',
    },
    webinars: {
        label: 'Webinars',
        value: 'webinars',
    },
});
